import React, { forwardRef, ComponentProps } from 'react';
import "cropperjs/dist/cropper.css";
import { Cropper } from 'react-cropper';
import { ReactCropperElement } from "react-cropper";

type Props = ComponentProps<typeof Cropper>;

const CropperWrapper = forwardRef<ReactCropperElement, Props>((props, ref) => {
    return (
        <Cropper
            ref={ref}
            {...props}
        />
    );
});

export default CropperWrapper;
